export const mockCampaigns = [
  {
    id: 1,
    name: "New Bordeaux Collection Launch",
    type: "Product Launch",
    status: "Active",
    startDate: "2025-01-10",
    endDate: "2025-02-28",
    targetProducts: ["Château Margaux 2023", "Château Latour 2023"],
    targetRegions: ["United States", "United Kingdom"],
    message: "Discover our exclusive 2023 Bordeaux collection featuring limited edition vintages from renowned châteaux.",
    discountType: "percentage",
    discountValue: 15,
    scanTrigger: "first_scan",
    redemptionLimit: 100,
    reach: 2547,
    engagement: 324,
    conversions: 45,
    scans: 1247,
    budget: 15000,
    createdAt: "2025-01-08T10:00:00Z",
    updatedAt: "2025-01-15T14:30:00Z"
  },
  {
    id: 2,
    name: "Q1 Allocation Notice",
    type: "Allocation",
    status: "Draft",
    startDate: "2025-02-01",
    endDate: "2025-02-15",
    targetAudience: "VIP Members",
    message: "Your Q1 wine allocation is ready. Reserve your premium selections before they're gone.",
    reach: 0,
    engagement: 0,
    conversions: 0,
    budget: 5000,
    createdAt: "2025-01-14T09:15:00Z",
    updatedAt: "2025-01-14T09:15:00Z"
  },
  {
    id: 3,
    name: "Authentication Verification Reminder",
    type: "Authentication Alerts",
    status: "Active",
    startDate: "2025-01-01",
    endDate: "2025-12-31",
    targetAudience: "All Customers",
    message: "Verify your wine's authenticity by scanning the NFC tag. Protect yourself from counterfeit products.",
    reach: 8932,
    engagement: 1247,
    conversions: 892,
    budget: 8000,
    createdAt: "2024-12-28T16:20:00Z",
    updatedAt: "2025-01-15T11:45:00Z"
  },
  {
    id: 4,
    name: "Loyalty Rewards Program",
    type: "Loyalty",
    status: "Active",
    startDate: "2024-12-01",
    endDate: "2025-03-31",
    targetAudience: "Repeat Customers",
    message: "Earn points with every verification and unlock exclusive rewards, early access, and special discounts.",
    reach: 4321,
    engagement: 876,
    conversions: 234,
    budget: 12000,
    createdAt: "2024-11-25T13:10:00Z",
    updatedAt: "2025-01-10T08:22:00Z"
  },
  {
    id: 5,
    name: "Summer Collection Preview",
    type: "Product Launch",
    status: "Paused",
    startDate: "2025-06-01",
    endDate: "2025-08-31",
    targetAudience: "Summer Wine Enthusiasts",
    message: "Get ready for summer with our refreshing collection of rosés and light whites.",
    reach: 156,
    engagement: 23,
    conversions: 2,
    budget: 10000,
    createdAt: "2025-01-05T11:30:00Z",
    updatedAt: "2025-01-12T15:45:00Z"
  },
  {
    id: 6,
    name: "Holiday Allocation 2024",
    type: "Allocation",
    status: "Completed",
    startDate: "2024-11-15",
    endDate: "2024-12-24",
    targetAudience: "Premium Members",
    message: "Secure your holiday wine selections from our exclusive reserve collection.",
    reach: 3892,
    engagement: 789,
    conversions: 456,
    budget: 20000,
    createdAt: "2024-11-01T10:00:00Z",
    updatedAt: "2024-12-24T23:59:00Z"
  }
];

export const campaignTypes = [
  { value: 'Allocation', label: 'Allocation', color: '#173131', description: 'Notify customers about wine allocations when they scan bottles' },
  { value: 'Product Launch', label: 'Product Launch', color: '#5F011E', description: 'Announce new wine releases with scan-to-purchase discounts' },
  { value: 'Authentication Alerts', label: 'Authentication Alerts', color: '#A59063', description: 'Educational content and rewards for scanning authentic bottles' },
  { value: 'Loyalty', label: 'Loyalty', color: '#EDDDD3', description: 'Scan-to-earn rewards and discount tiers for frequent scanners' }
];

export const discountTypes = [
  { value: 'none', label: 'No Discount' },
  { value: 'percentage', label: 'Percentage Off' },
  { value: 'fixed', label: 'Fixed Amount Off' },
  { value: 'buy_x_get_y', label: 'Buy X Get Y' }
];

export const scanTriggers = [
  { value: 'first_scan', label: 'First Scan Only' },
  { value: 'any_scan', label: 'Any Scan' },
  { value: 'repeat_scan', label: 'Repeat Scanners Only' },
  { value: 'daily_scan', label: 'Once Per Day' }
];

export const mockProducts = [
  'Château Margaux 2023',
  'Château Latour 2023',
  'Dom Pérignon 2019',
  'Opus One 2020',
  'Caymus Cabernet 2022',
  'Premium Reserve Collection',
  'All Products'
];

export const mockRegions = [
  'United States',
  'United Kingdom',
  'France',
  'Germany',
  'Australia',
  'Canada',
  'Italy',
  'Global'
];

export const campaignStatuses = [
  { value: 'Draft', label: 'Draft', color: '#9E9E9E' },
  { value: 'Active', label: 'Active', color: '#4CAF50' },
  { value: 'Paused', label: 'Paused', color: '#FF9800' },
  { value: 'Completed', label: 'Completed', color: '#2196F3' }
];